/**
 * @module FieldSettings
 * @preferred
 *
 * @description Module for FieldSettings.
 *
 * FieldSetting object is the implementation of the configuration element in a Sense/Net Content Type Definition.
 * The FieldSetting of a Field contains properties that define the behavior of the Field - for example a Field can be configured as read only or compulsory to fill.
 * FieldSettings helps us to autogenerate type and schema TS files from Sense/Net CTDs and use these files to reach all the configuration options of the Content Types fields on
 * client-side e.g. for validation.
 *
 * This module also contains some FieldSetting related enums to use them as types in properties e.g. visibitily or datetime mode options.
 */

/**
 * Enum for Field visibility values.
 */
export let FieldVisibility;
/**
 * Enum for Field output method values.
 */

(function (FieldVisibility) {
  FieldVisibility[FieldVisibility["Show"] = 0] = "Show";
  FieldVisibility[FieldVisibility["Hide"] = 1] = "Hide";
  FieldVisibility[FieldVisibility["Advanced"] = 2] = "Advanced";
})(FieldVisibility || (FieldVisibility = {}));

export let OutputMethod;
/**
 * Enum for Choice Field control values.
 */

(function (OutputMethod) {
  OutputMethod[OutputMethod["Default"] = 0] = "Default";
  OutputMethod[OutputMethod["Raw"] = 1] = "Raw";
  OutputMethod[OutputMethod["Text"] = 2] = "Text";
  OutputMethod[OutputMethod["Html"] = 3] = "Html";
})(OutputMethod || (OutputMethod = {}));

export let DisplayChoice;
/**
 * Enum for DateTime Field mode values.
 */

(function (DisplayChoice) {
  DisplayChoice["DropDown"] = "DropDown";
  DisplayChoice["RadioButtons"] = "RadioButtons";
  DisplayChoice["CheckBoxes"] = "CheckBoxes";
})(DisplayChoice || (DisplayChoice = {}));

export let DateTimeMode;
/**
 * Enum for DateTime Field precision values.
 */

(function (DateTimeMode) {
  DateTimeMode["None"] = "None";
  DateTimeMode["Date"] = "Date";
  DateTimeMode["DateAndTime"] = "DateAndTime";
})(DateTimeMode || (DateTimeMode = {}));

export let DateTimePrecision;
/**
 * Type for LongText field editor values.
 */

(function (DateTimePrecision) {
  DateTimePrecision["Millisecond"] = "Millisecond";
  DateTimePrecision["Second"] = "Second";
  DateTimePrecision["Minute"] = "Minute";
  DateTimePrecision["Hour"] = "Hour";
  DateTimePrecision["Day"] = "Day";
})(DateTimePrecision || (DateTimePrecision = {}));

/**
 * Check if field setting is type of param
 * @template T
 * @param {FieldSetting} setting
 * @param {new () => T} type
 */
export function isFieldSettingOfType(setting, type) {
  return setting.Type === type.name;
}
//# sourceMappingURL=FieldSettings.js.map